import { Injectable }       from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }               from '../api/api.service';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { ConfirmService }           from '../messages/confirm/confirm.service';
import { RepcoSettingsModel }       from './typings/repco.settings';
import { withoutBlankPassword }     from '../companies/company.supplier-password';

@Injectable({
  providedIn: 'root'
})
export class RepcoService {
  title = 'Repco';

  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private translateService: TranslateService
  ) {}

  purchase () : ng.IPromise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.PURCHASE_INTEGRATION', {
      name: this.title
    }))
    .then(() => this.apiService.get('/company/add_repco'));
  }

  remove () : ng.IPromise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.REMOVE_INTEGRATION', {
      name: this.title
    }))
    .then(() => this.apiService.get('/company/remove_repco'));
  }

  save ( settings : RepcoSettingsModel, companySettings : CompanyIntegrationsModel ) : ng.IPromise<CompanyIntegrationsModel> {
    return this.apiService.patch('/company', withoutBlankPassword(settings, 'repco_password'), 'company')
    .then(() => this.apiService.patch('/company_integrations', companySettings, 'company_integration'));
  }
}
